/* src/app/reflections/reflections.component.scss */
.reflections {
  background: white;
  color: black;
  height: 100%;
  padding: 150px 200px;
  font-family: "Campton-Light";
  text-align: left;
  font-size: 21px;
}
.reflections img {
  margin: 14px 0 50px;
}
.reflections ul {
  list-style-position: outside;
  margin-bottom: 1rem;
  margin: 0px;
  padding: 0px;
  margin-left: 1.25rem;
  margin-top: 1rem;
}
.reflections p {
  margin-bottom: 1rem;
  font-size: inherit;
  line-height: 1.6;
  text-rendering: optimizeLegibility;
}
.reflections h1 {
  font-size: 56px;
  line-height: 1.29;
  letter-spacing: 0.8px;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  font-weight: 700;
  font-family: "Campton-Bold";
}
.reflections a,
.reflections a:hover {
  color: #cca777;
  text-decoration: underline;
}
.reflections .dash {
  display: inline-block;
  width: 80px;
  height: 8px;
  padding: 0;
  margin: 0 0 24px;
  line-height: 8px;
}
.reflections .pressDash {
  background-color: #ff495c;
}
.reflections .newsDash {
  background-color: #d1a66f;
}
.reflections .buttons {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
/*# sourceMappingURL=reflections.component.css.map */
